import React, { useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { get } from 'lodash';
import CustomAccordion from 'containers/LawyerLegalProceedingsPage/CivilProceedingRecap/CustomAccordion';
import { COLORS } from 'constants/design';
import expertiseExpertiseIcon from 'images/expert-expertise-icon.svg';
import ValidationDialog from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/Dialog/ValidationDialog';
import RejectionDialog from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/Dialog/RejectionDialog';
import MedicalFormRecap from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/ExpertReport/MedicalFormRecap';
import AccountingFormRecap from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/ExpertReport/AccountingFormRecap';
import AppreciationDialog from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/Dialog/AppreciationDialog';
import { useDispatch, useSelector } from 'react-redux';
import {
  requestAddAppreciation,
  requestGetExpertUsers,
} from 'containers/CourtManagerLegalProceedings/actions';
import { resolveExpertiseType } from 'containers/CourtManagerLegalProceedings/utils';
import { makeSelectCorporealExperts } from 'containers/RecapManagerPage/selectors';
import { makeSelectListings } from 'containers/AppContainer/selectors';
import { EXPERTISE_MEDICAL_ID } from 'containers/ExpertExpertise/ConcernedExpertise/constants';
import { renderTitleCustomAccordion } from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/ExpertReport/utils';
import { EXPERTISE_ACCOUNTING_ID } from 'containers/CourtManagerLegalProceedings/constants';
import MechanicalFormRecap from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/ExpertReport/MechanicalFormRecap';
import { translate } from 'containers/services/translate';
import messages from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/messages';
export interface RecapReportProps {
  intl: IntlShape;
  recap: any;
  requestMakeDecisionMissionExpertise: Function;
  isLawyer?: boolean;
  claimNumber: string;
  riskKey: string;
  setOpenFeeNoteDialog: Function;
  isTransaction?: boolean;
  transactionId?: any;
  timelineId?: any;
  expertises?: any;
  responsibilityShare?: any;
  victims?: any;
  lossDate?: any;
  requestGetDocByDocumentumId: Function;
}
const RecapReport: React.FC<RecapReportProps> = props => {
  const dispatch = useDispatch();
  const [openDialogValidation, setOpenDialogValidation] = useState(false);
  const [openDialogRejection, setOpenDialogRejection] = useState(false);
  const [openDialogAppreciation, setOpenDialogAppreciation] = useState(false);
  const listings = useSelector(makeSelectListings());
  const corporealExperts = useSelector(makeSelectCorporealExperts());

  const handleOpenDialogValidation = () => {
    setOpenDialogValidation(true);
  };

  const handleOpenDialogRejection = () => {
    setOpenDialogRejection(true);
  };

  const handleOpenDialogAppreciation = () => {
    setOpenDialogAppreciation(true);
    dispatch(
      requestGetExpertUsers(
        resolveExpertiseType(Number(get(props.recap, 'mission.type'))),
      ),
    );
  };

  const renderRecapByMissionType = () => {
    if (Number(props.recap.mission.type) === EXPERTISE_MEDICAL_ID) {
      return (
        <MedicalFormRecap
          recap={props.recap}
          handleOpenDialogValidation={handleOpenDialogValidation}
          handleOpenDialogRejection={handleOpenDialogRejection}
          handleOpenAppreciationDialog={handleOpenDialogAppreciation}
          isLawyer={props.isLawyer}
          isTransaction={props.isTransaction}
          expertises={props.expertises}
          requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
        />
      );
    } else if (
      Number(props.recap.mission.type) === EXPERTISE_ACCOUNTING_ID &&
      get(props.recap, 'mission.victims')
    ) {
      return (
        <AccountingFormRecap
          recap={props.recap}
          handleOpenDialogValidation={handleOpenDialogValidation}
          handleOpenDialogRejection={handleOpenDialogRejection}
          handleOpenAppreciationDialog={handleOpenDialogAppreciation}
          isLawyer={props.isLawyer}
          isTransaction={props.isTransaction}
          requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
        />
      );
    } else if (
      Number(props.recap.mission.type) === EXPERTISE_ACCOUNTING_ID &&
      get(props.recap, 'mission.vehicles')
    ) {
      return (
        <MechanicalFormRecap
          recap={props.recap}
          handleOpenDialogValidation={handleOpenDialogValidation}
          handleOpenDialogRejection={handleOpenDialogRejection}
          handleOpenAppreciationDialog={handleOpenDialogAppreciation}
          isLawyer={props.isLawyer}
          requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
        />
      );
    } else {
      return (
        <MechanicalFormRecap
          recap={props.recap}
          handleOpenDialogValidation={handleOpenDialogValidation}
          handleOpenDialogRejection={handleOpenDialogRejection}
          handleOpenAppreciationDialog={handleOpenDialogAppreciation}
          isLawyer={props.isLawyer}
          requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
        />
      );
    }
  };

  return (
    <CustomAccordion
      title={
        props.isTransaction
          ? translate(messages.accordionTitle, props, {
              reference: props.recap.mission.reference,
            })
          : renderTitleCustomAccordion(props.recap)
      }
      textColor={COLORS.ACCORDION_TEXT_BLUE}
      bgColor={COLORS.ACCORDION_BG_BLUE}
      image={expertiseExpertiseIcon}
    >
      {renderRecapByMissionType()}
      <ValidationDialog
        open={openDialogValidation}
        recap={props.recap}
        claimNumber={props.claimNumber}
        onClose={() => setOpenDialogValidation(false)}
        validateDialog={props.requestMakeDecisionMissionExpertise}
        setOpenFeeNoteDialog={props.setOpenFeeNoteDialog}
        transactionId={props.transactionId}
        timelineId={props.timelineId}
        allExpertReport={props.expertises}
        responsibilityShare={props.responsibilityShare}
        victims={props.victims}
        lossDate={props.lossDate}
        riskKey={props.riskKey}
      />
      <RejectionDialog
        open={openDialogRejection}
        recap={props.recap}
        claimNumber={props.claimNumber}
        onClose={() => setOpenDialogRejection(false)}
        validateDialog={props.requestMakeDecisionMissionExpertise}
        transactionId={props.transactionId}
        timelineId={props.timelineId}
      />
      <AppreciationDialog
        open={openDialogAppreciation}
        onClose={() => setOpenDialogAppreciation(false)}
        validateDialog={(payload: any, successCallBack: Function) =>
          dispatch(
            requestAddAppreciation(
              { ...payload, riskKey: props.riskKey },
              successCallBack,
            ),
          )
        }
        recap={props.recap}
        corporealExperts={corporealExperts}
        listings={listings}
        claimNumber={props.claimNumber}
        transactionId={props.transactionId}
        timelineId={props.timelineId}
      />
    </CustomAccordion>
  );
};

export default injectIntl(RecapReport);
